/* eslint-disable */
YP.FacebookManager = function() {
    var loginStatus = false,
        registerUrl = constructUrl('register/facebook');
    return {
        init: function() {
            $("a.facebook-login").on('click', this.login);
            $("body").on('click', ".modal-content a.facebook-login", this.login);
        },
        checkFacebookLoginStatus: function() {
            var deferred = $.Deferred();
            FB.getLoginStatus(function(response) {
                deferred.resolve(response.status);
            });
            return deferred.promise();
        },
        checkFacebookPermissions: function(permToCheck) {
            var deferred = $.Deferred();
            FB.api('/me/permissions', function(response) {
                if (permToCheck) {
                    deferred.resolve(response.data.filter(function(obj) {
                        return obj.permission == permToCheck
                    })[0].status);
                } else {
                    deferred.resolve(response);
                }
            });
            return deferred.promise();
        },
        checkYpUserViaFb: function() {
            var deferred = $.Deferred();
            $.ajax({
                type: 'GET',
                dataType: 'json',
                url: constructUrl('register/facebook/check'),
                success: function(data) {
                    deferred.resolve(data.isSubscribe);
                },
            });
            return deferred.promise();
        },
        login: function(e) {
            e.preventDefault();
            perms = $(this).data("perms");
            if (perms) {
                scope = 'email,' + perms;
            } else {
                scope = 'email';
            }
            FB.login(function(response) {
                if (response.authResponse) {
                    //On check si la persmission email existe
                    $.when(YP.FacebookManager().checkFacebookPermissions("email")).done(function(isGranted) {
                        if (isGranted == "declined") {
                            //On check si l'user est deja inscrit sur Yurplan et a une adresse email
                            $.when(YP.FacebookManager().checkYpUserViaFb()).done(function(isSubscribe) {
                                if (isSubscribe) {
                                    window.location = registerUrl;
                                } else {
                                    YP.ModalManager().loadModal(constructUrl('register/facebook/email'));
                                }
                            });
                        } else {
                            window.location = registerUrl;
                        }
                    });
                } else {
                    location.reload();
                }
            }, {
                scope: scope,
                auth_type: 'rerequest'
            });
        }
    }
};

window.addEventListener("load", function() {
    $.ajaxSetup({
        cache: true
    });
    if(document.cookie.indexOf('FACEBOOK_CONNEXION') > -1) {
    $.getScript('https://connect.facebook.net/fr_FR/sdk.js', function() {
        FB.init({
            appId: $("meta[property='fb:app_id']").attr('content'),
            status: true, // check login status
            cookie: true, // enable cookies to allow the server to access the session
            xfbml: true,
            version: 'v3.2'
        });
    });
    YP.FacebookManager().init();
    } else {
        var fbmCookieRegex = document.cookie.match(/(fbm_\d+)=/);
        var fbsrCookieRegex = document.cookie.match(/(fbsr_\d+)=/);
        var fbmCookie = ''
        var fbsrCookie = ''
        if (fbmCookieRegex && fbmCookieRegex.length >= 2) {
            fbmCookie = fbmCookieRegex[1];
        }
        if (fbsrCookieRegex && fbsrCookieRegex.length >= 2) {
            fbsrCookie = fbsrCookieRegex[1];
        }
        if(CookiesHelpers.getCookie(fbmCookie) && document.cookie.indexOf('FACEBOOK_PIXEL') < 0) {
            CookiesHelpers.setCookie(fbmCookie, 0, -1);
        }
        if(CookiesHelpers.getCookie(fbsrCookie) && document.cookie.indexOf('FACEBOOK_PIXEL') < 0) {
            CookiesHelpers.setCookie(fbsrCookie, 0, -1);
        }
    }
});
